import "./Regions.scss";
import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import { debounce, uniqBy } from "lodash";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  data: () => ({
    headers: [
      { text: "Titel", value: "title", sortable: false },
      { text: "Mandant", value: "principal.name", sortable: false },
      { text: "Id", value: "_id", sortable: false },
      {
        text: "Aktionen",
        value: "actionChange",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    cancelPoiRequest: null,
    dialog: false,
    isValid: false,
    loading: false,
    editedItem: {},
    poisValue: [],
    permissionItems: [
      { value: "admin", title: "Admin" },
      { value: "write", title: "Schreiben" },
      { value: "read", title: "Lesen" },
      { value: "status", title: "Statusbearbeitung" }
    ],
    defaultFilter: { searchText: "", itemsPerPage: 25 },
    filter: {},
    search: "",
    options: {},
    connectionTypes: [
      "weather.com",
      "tripadvisor",
      "trustyou",
      "meaneo",
      "Planquadrat",
      "mapping-id",
      "Tramino-ID",
      "Feratel-ID",
      "OutdoorActive-ID",
      "Toubiz-ID",
      "Infomax-ID",
      "DetinationData-ID",
      "RCE-ID",
      "Travel-ID",
      "App-Kategorie",
      "Shoplink"
    ],
    selectedConnectionType: "weather.com",
    isSaving: false
  }),
  async mounted() {
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    await this.fetchData();

    if (!this.editedItem?.principalId)
      this.editedItem.principalId = this.currentPrincipal;
  },
  components: { AdminList },
  computed: {
    regions() {
      return this.$store.state.regions;
    },
    principals() {
      return this.$store.state.principals;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    selectedPois: {
      get() {
        return uniqBy(this.editedItem.pois ?? [], "_id");
      },
      set(value) {
        const items = value.map(poiId => {
          const existingItem = this.editedItem.pois?.find(
            editedItemPoi => editedItemPoi?._id === poiId
          );

          if (existingItem)
            return {
              ...existingItem,
              permissions: existingItem.permissions ?? "read"
            };
          else {
            const newItem = this.pois?.find(poi => poi._id === poiId);
            if (newItem) return { ...newItem, permissions: "read" };
            else return { _id: poiId, permissions: "read", additionalData: [] };
          }
        });

        this.editedItem.pois = uniqBy(items, "_id");
        this.$forceUpdate();
      }
    },
    pois: {
      get() {
        return this.poisValue;
      },
      set(value) {
        this.poisValue = uniqBy(value, "_id");
      }
    }
  },
  methods: {
    async close() {
      this.editedItem = {};
      this.dialog = false;
      await this.fetchData();
    },
    async editItem(region) {
      if (region?._id) {
        await this.$store.dispatch("getRegions", {
          _id: region._id
        });
        this.editedItem = this.$store.state.regions[0];
      }
      this.dialog = true;
    },
    async fetchPois() {
      //cancel outdated request
      if (this.cancelPoiRequest) {
        this.cancelPoiRequest();
      }
      try {
        let result = [];
        const headers = getTokenHeader();

        const principalResult = await axios.get(
          `${env.poi_api_client_url}poi/poisForRegions`,
          {
            params: {
              principal: this.currentPrincipal
            },
            headers,
            cancelToken: new axios.CancelToken(c => {
              this.cancelPoiRequest = c;
            })
          }
        );
        principalResult.data?.forEach(poi => {
          result.push(poi);
        });

        this.pois = result;
        this.loading = false;
      } catch (error) {
        if (axios.isCancel(error)) {
          console.info("Request cancelled successfully.");
          return;
        }
        await this.$store.dispatch("createError", error);
      }
    },
    async fetchData() {
      this.loading = true;
      const payload = {
        regionsList: true,
        principal_id: this.currentPrincipal
      };
      if (this.filter.searchText.length >= 3)
        payload.search = this.filter.searchText;
      await this.$store.dispatch("getRegions", payload);
      await this.fetchPois();
      this.loading = false;
    },
    async savePoi(poi) {
      try {
        const headers = getTokenHeader();
        await axios.put(
          `${env.poi_api_client_url}poi/${poi.id || poi._id}`,
          poi,
          { headers }
        );
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Fehler beim Speichern des POIs",
          error
        });
      }
    },
    async save(close, region) {
      if (!this.isSaving) {
        this.isSaving = true;
        let response;
        if (region._id) response = await this.updateRegion(region);
        else response = await this.createRegion(region);
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.fetchData();
        }
        if (response.status === 201) {
          this.editedItem = response.data;
          await this.$store.dispatch("createSuccess", "Erfolgreich angelegt!");
          await this.fetchData();
        }

        if (close) this.close();
        this.isSaving = false;
      }
    },
    async updateRegion(region) {
      try {
        return await this.$store.dispatch("updateRegion", region);
      } catch (error) {
        if (error?.response?.status === 409)
          await this.$store.dispatch("createError", {
            text: "Dieser Benutzername ist bereits vergeben!"
          });
        else await this.$store.dispatch("createError", error);
        return error.response;
      }
    },
    async createRegion(region) {
      try {
        return await this.$store.dispatch("createRegion", region);
      } catch (error) {
        if (error.response.status === 409)
          await this.$store.dispatch("createError", {
            text: "Dieser Benutzername ist bereits vergeben!"
          });
        else await this.$store.dispatch("createError", error);
        return error.response;
      }
    },
    getPOILabelById(id) {
      const poi = this.pois?.find(poi => poi._id === id);
      const principal = this.principals?.find(
        principal => principal.id === poi?.principal
      );
      let returnValue = "";
      if (poi?.title) returnValue += poi.title;
      if (principal?.name) returnValue += ` - ${principal.name}`;

      return returnValue;
    },
    buildQuery() {
      const query = {};
      if (this.filter.searchText?.length >= 3)
        query.search = this.filter.searchText;
      if (this.filter.mainPoi) query.mainPoi = this.filter.mainPoi;
      if (this.filter?.pois?.length) query["pois._id"] = this.filter.pois;
      if (this.filter?.principalId) query.principalId = this.filter.principalId;
      if (this.options.itemsPerPage) query.$limit = this.options.itemsPerPage;
      if (this.options.itemsPerPage && this.options.page)
        query.$limit = this.options.itemsPerPage * this.options.page;
      return query;
    },
    async resetFilter() {
      this.filter = {};
      this.search = "";
      await this.fetchData();
    },
    async applyOptions(options) {
      this.options = options;
      await this.fetchData();
    },
    getConnectionValue(type, poi) {
      return poi?.additionalData?.find(item => item?.typeId === type)?.value;
    },
    setConnectionForPoi(value, typeId, poi) {
      const item = poi.additionalData.find(item => item?.typeId === typeId);
      if (item) item.value = value;
      else poi.additionalData.push({ typeId, value });
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.fetchData();
    }, 500)
  }
};
